import "core-js/modules/es6.object.define-properties";
import "core-js/modules/es7.object.get-own-property-descriptors";
import "core-js/modules/es6.array.for-each";
import "core-js/modules/es6.array.filter";
import "core-js/modules/es6.symbol";
import "core-js/modules/es6.array.index-of";
import "core-js/modules/web.dom.iterable";
import "core-js/modules/es6.array.iterator";
import "core-js/modules/es6.object.to-string";
import "core-js/modules/es6.object.keys";
import "core-js/modules/es6.object.define-property";
import "core-js/modules/es6.string.link";
import _isString from "lodash/isString";
import _merge from "lodash/merge";
import _isUndefined from "lodash/isUndefined";
import _pickBy from "lodash/pickBy";

var _LINK_TYPE_TO_TRK_ELE;

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

import { EDUCATION_LOANS_SUB_PRODUCT_TYPES } from '@nerdwallet/marketplace/constants';
import { getApplyLink, getId, getIssuerName, getLearnMoreLink, getProductType, getSlug, getSubProductType, getVersionId, isActive } from '@nerdwallet/marketplace/selectors/common';
import { isNonMonetizing } from '@nerdwallet/marketplace/utils';
import { PRODUCT_TYPES } from '@nerdwallet/nw-api-sdk/marketplace';
import { setTrk, TrkElement, TrkTag } from '@nerdwallet/nw-client-lib/trk-helper';
import MarketplaceReviewLink, { TRK_PRODUCT_LOCATION as TRK_PRODUCT_LOCATION_MRL } from '@nerdwallet/react-marketplace-review-link';
import { LINK_TYPES, RATES_LINK_EDUCATION_LOANS, RATES_LINK_PERSONAL_LOANS, TRK_PRODUCT_LOCATION } from '../constants';
import mapPropsAutoLoans from './auto-loans';
import mapPropsBanking from './banking';
import mapPropsCreditCards from './credit-cards';
import mapPropsEducationLoans from './education-loans';
import mapPropsInvesting from './investing';
import mapPropsMortgages from './mortgages';
import mapPropsPersonalLoans from './personal-loans';
import mapPropsSmbLoans from './small-medium-business-loans';
var LINK_TYPE_TO_TRK_ELEMENT_MAP = (_LINK_TYPE_TO_TRK_ELE = {}, _defineProperty(_LINK_TYPE_TO_TRK_ELE, LINK_TYPES.BUTTON, TrkElement.button), _defineProperty(_LINK_TYPE_TO_TRK_ELE, LINK_TYPES.LINK, TrkElement.hyperlink), _LINK_TYPE_TO_TRK_ELE);
export var linksToReview = function linksToReview(mergedProps) {
  return mergedProps.CtaComponent === MarketplaceReviewLink;
};
export default (function (_ref) {
  var link = _ref.link,
      props = _objectWithoutProperties(_ref, ["link"]);

  // Clear out any undefined props
  var definedProps = _pickBy(props, function (val) {
    return !_isUndefined(val);
  });

  var marketplaceEntity = definedProps.marketplaceEntity,
      productLocation = definedProps.productLocation,
      reviewLink = definedProps.reviewLink,
      shouldLogImpression = definedProps.shouldLogImpression,
      trkElement = definedProps.trkElement,
      trkSectionCategory = definedProps.trkSectionCategory,
      trkTaxonomy = definedProps.trkTaxonomy,
      trkPageType = definedProps.trkPageType,
      type = definedProps.type;
  var nonMonetizingTrkLocation = [TRK_PRODUCT_LOCATION, TRK_PRODUCT_LOCATION_MRL];

  if (productLocation && productLocation !== TRK_PRODUCT_LOCATION) {
    nonMonetizingTrkLocation.unshift(productLocation);
  }

  var reviewLinkProps = {
    CtaComponent: MarketplaceReviewLink,
    // getLearnMoreLink returns the review link for all verticals except Credit Cards (which is handled separately and links to the card details page)
    href: reviewLink || getLearnMoreLink(marketplaceEntity),
    text: 'Read review',
    trkLocation: nonMonetizingTrkLocation.join('-')
  };
  var mappedProps = {}; // If `link` is a legitimate override, put it back into props.
  // Otherwise, a falsy value will fallback to the value taken from marketplaceEntity.

  if (link) {
    _merge(definedProps, {
      link: link
    });
  }

  switch (getProductType(marketplaceEntity)) {
    case PRODUCT_TYPES.AUTO_LOANS:
      mappedProps = mapPropsAutoLoans(definedProps);
      break;

    case PRODUCT_TYPES.BANKING:
      mappedProps = mapPropsBanking(definedProps);
      break;

    case PRODUCT_TYPES.CREDIT_CARDS:
      mappedProps = mapPropsCreditCards(definedProps);

      if (!reviewLink) {
        reviewLinkProps.href = null;
        reviewLinkProps.text = 'Learn more';
      }

      break;

    case PRODUCT_TYPES.INVESTING:
      mappedProps = mapPropsInvesting(definedProps);
      break;

    case PRODUCT_TYPES.MORTGAGES:
      mappedProps = mapPropsMortgages(definedProps);
      break;

    case PRODUCT_TYPES.PERSONAL_LOANS:
      mappedProps = mapPropsPersonalLoans(definedProps);
      reviewLinkProps.href = RATES_LINK_PERSONAL_LOANS;
      reviewLinkProps.text = 'See my rates';
      reviewLinkProps.subtext = "on NerdWallet's secure website";
      break;

    case PRODUCT_TYPES.EDUCATION_LOANS:
      mappedProps = mapPropsEducationLoans(definedProps); // Origination loans should continue to go to the review page,
      // but all other subtypes will go to the rates tool page

      if (getSubProductType(marketplaceEntity) !== EDUCATION_LOANS_SUB_PRODUCT_TYPES.ORIGINATION) {
        reviewLinkProps.href = RATES_LINK_EDUCATION_LOANS;
        reviewLinkProps.text = 'See my rates';
        reviewLinkProps.subtext = "on NerdWallet's secure website";
      }

      break;

    case PRODUCT_TYPES.SMB_LOANS:
      mappedProps = mapPropsSmbLoans(definedProps);
      break;

    default:
      mappedProps = {};
      break;
  }

  if (!(isNonMonetizing(marketplaceEntity) || !isActive(marketplaceEntity) && getProductType(marketplaceEntity) === PRODUCT_TYPES.CREDIT_CARDS)) {
    reviewLinkProps = {};
  } // Merge props to allow manual overrides.


  var mergedProps = _objectSpread(_objectSpread(_objectSpread({
    issuer: getIssuerName(marketplaceEntity),
    link: getApplyLink(marketplaceEntity),
    logImpression: shouldLogImpression,
    offerVersionId: getVersionId(marketplaceEntity),
    productId: getId(marketplaceEntity),
    productSlug: getSlug(marketplaceEntity),
    showIcon: false
  }, mappedProps), reviewLinkProps), definedProps); // Add tracking to links


  if (mergedProps.link && _isString(mergedProps.link)) {
    var _params;

    mergedProps.link = setTrk({
      url: mergedProps.link,
      taxonomy: trkTaxonomy,
      params: (_params = {}, _defineProperty(_params, TrkTag.location, TRK_PRODUCT_LOCATION), _defineProperty(_params, TrkTag.element, trkElement || LINK_TYPE_TO_TRK_ELEMENT_MAP[type]), _defineProperty(_params, TrkTag.pageType, trkPageType), _defineProperty(_params, TrkTag.sectionCategory, trkSectionCategory), _params)
    });
  }

  return mergedProps;
});